import React, { useEffect, useState } from "react";
import { StyledSectionHeaderComponent, StyledListContainer, StyledListSection } from "../utils/common-styles";
import { Col, Row } from "react-bootstrap";
import { useHttp } from "../hooks/use-http";
import { ArticleItemDetail } from "../components/Articles/ArticleItemDetail";
import { ArticleItemSideBar } from "../components/Sidebar/Articles/ArticleItemSideBar";
import { Helmet } from "react-helmet";
import { UrlFixer } from "../utils/utils";

export const VolunteeringPage = (props) => {
  const id = 4;

  const [article, setArticle] = useState({});
  const [otherArticles, setOtherArticles] = useState([]);

  const { isLoading, sendRequest: getContent } = useHttp();

  useEffect(() => {
    const parseContent = (data) => {
      let article = data?.payload?.article;
      let otherArticles = data?.payload?.other;
      setArticle((prevState) => {
        return { ...prevState, ...article };
      });

      setOtherArticles((prevState) => {
        return otherArticles;
      });
    };

    let url = `/articles/item/${id}/detail`;
    getContent({ url }, parseContent);
  }, [id, getContent]);

  return (
    <>
      <Helmet>
        <title>Volunteering - The Friends of Queen's Wood</title>
        <meta name="description" content="Find out how you can get involved with The Friends of Queen's Wood" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Volunteering - The Friends of Queen's Wood" />
        <meta property="og:description" content="Find out how you can get involved with The Friends of Queen's Wood" />
        <meta property="og:url" content={`${window.location.origin}`} />
        <meta property="og:image" content={UrlFixer('/assets/og-large-profile.jpg')} />
        <meta name="twitter:title" content="Volunteering - The Friends of Queen\'s Wood" />
        <meta name="twitter:description" content="Find out how you can get involved with The Friends of Queen\'s Wood" />
        <meta name="twitter:image" content={UrlFixer('/assets/og-large-profile.jpg')} />
      </Helmet>
      <StyledSectionHeaderComponent title="Volunteering" />
      <StyledListSection>
        <StyledListContainer>
          <Row>
            <Col xs={12} md={9}>
              <p style={{ marginTop: "25px" }}>&nbsp;</p>
              {!isLoading && <ArticleItemDetail post={article} />}
            </Col>
            <Col xs={12} md={3}>
              {!isLoading && <ArticleItemSideBar post={article} other={otherArticles} />}
            </Col>
          </Row>
        </StyledListContainer>
      </StyledListSection>
    </>
  );
};
